export default function removeAccents (str) {
    if (str) {
        return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    } else {
        return null
    }
}